import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
} from '@mui/material';
import { useState, useEffect } from 'react';

export default function CouponFormDialog({
	open,
	onClose,
	onSubmit,
	initialData,
	couponSubmit,
}: any) {
	const [formData, setFormData] = useState<any>({
		code: '',
		description: '',
		type: 'amount',
		value: '',
		minPurchaseAmount: '',
		startDate: '',
		endDate: '',
	});

	useEffect(() => {
		setFormData({
			code: initialData?.code || '',
			description: initialData?.description || '',
			type: initialData?.type || 'amount',
			value: initialData?.value || '',
			minPurchaseAmount: initialData?.minPurchaseAmount || '',
			startDate: initialData?.startDate?.split('T')[0] || '',
			endDate: initialData?.endDate?.split('T')[0] || '',
		});
		if (couponSubmit) {
			setFormData({
				code: '',
				description: '',
				type: 'amount',
				value: '',
				minPurchaseAmount: '',
				startDate: '',
				endDate: '',
			});
		}
	}, [initialData, couponSubmit]);

	const handleSubmit = () => {
		onSubmit(formData);
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>{initialData ? 'Edit Coupon' : 'Create Coupon'}</DialogTitle>
			<DialogContent>
				<TextField
					fullWidth
					margin="dense"
					size="small"
					label="Code"
					value={formData.code}
					onChange={(e) => setFormData({ ...formData, code: e.target.value })}
				/>
				<TextField
					fullWidth
					margin="dense"
					label="Description"
					size="small"
					value={formData.description}
					onChange={(e) => setFormData({ ...formData, description: e.target.value })}
				/>
				<FormControl fullWidth margin="dense" size="small">
					<InputLabel>Type</InputLabel>
					<Select
						label="Type"
						value={formData.type}
						onChange={(e) => setFormData({ ...formData, type: e.target.value })}
					>
						<MenuItem value="amount">Amount</MenuItem>
						<MenuItem value="percentage">Percentage</MenuItem>
					</Select>
				</FormControl>
				<TextField
					fullWidth
					margin="dense"
					label="Value"
					size="small"
					type="number"
					value={formData.value}
					onChange={(e) => setFormData({ ...formData, value: +e.target.value })}
				/>
				<TextField
					fullWidth
					margin="dense"
					label="Min Purchase Amount"
					type="number"
					size="small"
					value={formData.minPurchaseAmount}
					onChange={(e) =>
						setFormData({ ...formData, minPurchaseAmount: +e.target.value })
					}
				/>
				<TextField
					fullWidth
					margin="dense"
					label="Start Date"
					type="date"
					size="small"
					InputLabelProps={{ shrink: true }}
					value={formData.startDate}
					onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
				/>
				<TextField
					fullWidth
					margin="dense"
					label="End Date"
					type="date"
					size="small"
					InputLabelProps={{ shrink: true }}
					value={formData.endDate}
					onChange={(e) => setFormData({ ...formData, endDate: e.target.value })}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button variant="contained" onClick={handleSubmit}>
					{initialData ? 'Update' : 'Create'}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
